import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-box login"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Login", -1)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Password", -1)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "buttons" }, [
  /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Login")
], -1)
const _hoisted_11 = ["textContent"]

import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import User from '@/models/user.model';
import authService from '@/services/AuthService';
import { Actions } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const user = reactive<User>(new User({}));
const verified = ref<boolean>(false);
const error = ref<string | null>(null);

const redirect = computed<string>(() => {
  return route.query.redirect ? (route.query.redirect as string) : '/';
});

onMounted(() => {
  window.setTimeout(() => {
    if (authService.isLoggedIn()) {
      router.push(redirect.value);
    }
    verified.value = true;
  }, 100);
});

const submit = async (evt: Event) => {
  error.value = null;
  if (user.isValid()) {
    const response = await store.dispatch(Actions.Login, user.data());
    if (response.status) {
      router.push(redirect.value);
    } else {
      error.value = response.message;
    }
  }
  evt.preventDefault();
};

return (_ctx: any,_cache: any) => {
  return (verified.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.name) = $event))
            }, null, 512), [
              [_vModelText, user.name]
            ]),
            (!user.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(user.validation.messages.name)
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              name: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.password) = $event))
            }, null, 512), [
              [_vModelText, user.password]
            ]),
            (!user.isValid('password'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(user.validation.messages.password)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _hoisted_10,
          (error.value)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "validation form",
                textContent: _toDisplayString(error.value)
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true)
        ], 40, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}
}

})